import React from "react";
import { Button, Group } from "@mantine/core";
import { ChartArrows, Refresh } from "tabler-icons-react";
import { getLogLevel } from "./logUtils";

const countLevel = (data, level) =>
  data.filter((item) => getLogLevel(item) === level).length;

const OccurencyDetails = ({
  data = [],
  userSteps = [],
  onUserStepsClick,
  handleRefresh,
}) => {
  const errors = countLevel(data, "error");
  const warns = countLevel(data, "warn");

  return (
    <div className="metrics-strip">
      <Group spacing={10}>
        <div className="metric-pill">
          <span>Total</span>
          <strong>{data.length}</strong>
        </div>
        <div className="metric-pill metric-pill--error">
          <span>Errors</span>
          <strong>{errors}</strong>
        </div>
        <div className="metric-pill metric-pill--warn">
          <span>Warns</span>
          <strong>{warns}</strong>
        </div>
      </Group>
      <Group spacing={8}>
        <Button
          variant="subtle"
          leftIcon={<Refresh size={15} />}
          onClick={handleRefresh}
          compact
          className="toolbar-button"
        >
          Refresh
        </Button>
        {userSteps.length > 0 && (
          <Button
            onClick={onUserStepsClick}
            variant="subtle"
            leftIcon={<ChartArrows size={15} />}
            compact
            className="toolbar-button"
          >
            User steps ({userSteps.length})
          </Button>
        )}
      </Group>
    </div>
  );
};

export default OccurencyDetails;
